export default __webpack_public_path__ + "static/media/oil-platform.734fb055.png";